// React
import * as React from "react";
import { connect } from "react-redux";

//React Router
import { Redirect } from "react-router-dom";

// Components Material-UI
import Typography from "material-ui/Typography";
import PhotoCamera from "material-ui-icons/PhotoCamera";
import Power from "material-ui-icons/Power";
import ViewList from "material-ui-icons/ViewList";
import Tabs, { Tab } from "material-ui/Tabs";
import SwipeableViews from "react-swipeable-views";
import WarningIcon from "material-ui-icons/Warning";
import CircularProgress from "material-ui/Progress/CircularProgress";

// Components Artionet
import QrCodeReader from "./../components/QrCodeReader";

// Framework
import { getURLByEnv } from "../../framework/utils/URL";

//MainStore
import { MainStore } from "../../store/MainStore";

// Views
import Borrows from "./Borrows";
import Materials from "./Materials";

// Managers
import { NetworkManager } from "./../../managers/NetworkManager";
import { StyleManager } from "./../../managers/StyleManager";
import { UserProfile_e } from "../../framework/user/UserProfile";
import ColorManager from "../../managers/ColorManager";

// Style
const styles = StyleManager.getStyles().HomeView;

/**
 * @description Interface for the Home State
 * @author Lucas Fridez <lfridez@artionet.com>
 * @interface HomeState
 */
interface HomeState {
    lastTabShown: number;
    refreshBorrows: any;
    refreshMaterials: any;
    tabShown: number;
    value: Array<any>;
}

/**
 * @description Interface for the Home Props
 * @author Lucas Fridez <lfridez@artionet.com>
 * @interface HomeProps
 */
interface HomeProps {
    overlay: any;
}

/**
 * @description Component TabLabel
 * @author Lucas Fridez <lfridez@artionet.com>
 * @class TabLabel
 * @extends {React.Component}
 */
class TabLabel extends React.Component {
    render() {
        return (
            <div style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            }}>< Power /> Matériels</div>
        );
    }
}

/**
 * @description Contain the Home Component
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Home
 * @extends {React.Component}
 */
export default connect<{}, {}, HomeProps>((state) => state)(class Home extends React.Component<HomeProps, HomeState> {

    /**
     * Creates an instance of Home.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Home
     */
    constructor(props) {
        super(props);
        this.state = {
            lastTabShown: Number(window.sessionStorage.getItem("tabShown")) || 0,
            refreshBorrows: 0,
            refreshMaterials: 0,
            tabShown: Number(window.sessionStorage.getItem("tabShown")) || 0,
            value: []
        };
        NetworkManager.connect();
    }

    componentWillMount() {
        MainStore.getWarehouses();
    }

    /**
     * @description Component is now mounted in the App
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Home
     */
    public async componentDidMount() {
        NetworkManager.getUserCredentials();
    }

    /**
     * @description Change the actual shown tab
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param event Event used for the changement
     * @param value New shown tab
     * @memberof Home
     */
    handleChange = (event, value) => {
        window.sessionStorage.setItem("tabShown", value);
        this.setState({
            lastTabShown: this.state.tabShown,
            refreshBorrows: value == 2 ? this.state.refreshBorrows + 1 : this.state.refreshBorrows,
            refreshMaterials: value == 0 ? this.state.refreshMaterials + 1 : this.state.refreshMaterials,
            tabShown: value
        });
    }

    /**
     * @description Change the actual shown tab
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param tabShown The next tab that will be shown
     * @memberof Home
     */
    handleChangeIndex = (tabShown) => {
        window.sessionStorage.setItem("tabShown", tabShown);
        this.setState({ tabShown });
    }

    /**
     * @description Render the Home View
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns Home View
     * @memberof Home
     */
    render() {
        if (NetworkManager.getUserCredentials() === undefined) {
            return (<Redirect to={`${getURLByEnv()}/`} />);
        }
        return (
            <div>
                <SwipeableViews
                style={{height: "100%"}}
                    index={this.state.tabShown}
                    onChangeIndex={this.handleChangeIndex}>
                    <div style={{...styles.slide, position: "relative"}}><Materials refresh={this.state.refreshMaterials}/></div>
                    <div style={styles.slide}><QrCodeReader userProfile={NetworkManager.getUserProfile()} switched={this.state.tabShown === 1 ? true : false} /></div>
                    <div style={{...styles.slide, position: "relative"}}><Borrows userProfile={NetworkManager.getUserProfile()} refresh={this.state.refreshBorrows}/></div>
                </SwipeableViews>

                <Tabs
                    value={this.state.tabShown}
                    fullWidth
                    onChange={this.handleChange}
                    indicatorColor={styles.indicatorColor}
                    style={{
                        backgroundColor: "#1976D2",
                        bottom: 0,
                        left: 0,
                        position: "fixed",
                        right: 0
                    }}>
                    <Tab label={<TabLabel />} style={styles.icon} />
                    <Tab label={<div style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}>< PhotoCamera />Scanner</div>} style={styles.icon} />
                    <Tab label={<div style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}>< ViewList /> Emprunts</div>} style={styles.icon} />
                </Tabs>

                {this.props.overlay.overlay.show && < div id="overlay" style={{
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.65)",
                    bottom: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    left: 0,
                    position: "fixed",
                    right: 0,
                    top: 0
                }}>
                    {this.props.overlay.overlay.icon == "loading" &&
                        <CircularProgress style={{ color: ColorManager.whiteTransparency90 }} />
                    }
                    {this.props.overlay.overlay.icon == "error" &&
                        <WarningIcon style={{
                            color: ColorManager.whiteTransparency90,
                            height: "48px",
                            width: "48px"
                        }} />
                    }
                    <Typography type="headline" style={{ color: ColorManager.whiteTransparency90, marginTop: 16, textAlign: "center" }}>
                        {this.props.overlay.overlay.text}
                    </Typography>
                </div>}
            </div >
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/UI/views/Home.tsx